import { DefaultButton, IPanelStyles, ITextStyles, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, Text } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import React, { useEffect, useState } from 'react';
import { IField, ITextField, IUor } from '../../shared/interfaces';
import AppUtilities from '../../shared/Utilities/appUtilities';
import DynamicForm from '../DynamicForm/DynamicForm';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';


const textStyles: Partial<ITextStyles> = {
    root: {
        display: 'block',
        marginTop: '18px'
    }
}
const panelStyles: Partial<IPanelStyles> = {
    content: {
        padding: '24px 20px 0px',
        display: 'flex',
        flexFlow: 'column',
        overflow: 'hidden',
    },
    scrollableContent: {
        display: 'flex',
        flexFlow: 'column',
        overflow: 'hidden',

    }
}

const initialFields: IField[] = [
    {
        displayName: "Nome",
        internalName: "nome",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    },
    {
        displayName: "Sigla",
        internalName: "sigla",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        maxLength: 5 //da gestire

    } as ITextField,
    {
        displayName: "Alias",
        internalName: "alias",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    },
];

export interface AddEditUorProps {
    loading?: boolean
    extraCssClass?: string
    selectedUor?: IUor
    panelHeaderText: string
    iaAssistantEnabled: boolean
    panelIsOpen: boolean
    panelIsEdit: boolean
    onSubmit: (uor: Partial<IUor>) => void
    onDismiss: () => void
}


const AddEditUor: React.FunctionComponent<AddEditUorProps> = (props) => {
    let loading = props.loading !== undefined ? props.loading : false;

    const [panelIsOpen, setPanelIsOpen] = useState<boolean>(props.panelIsOpen);
    const [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>();
    const [messageBarText, setMessageBarText] = useState<string>('');
    const [fields, setFields] = useState<IField[]>([]);

    //const [newUor, setNewUor] = useState<IUor>();


    useEffect(() => {
        setPanelIsOpen(props.panelIsOpen);

        dismissMessageBar();
        onDismiss();

    }, [props.panelIsOpen]);

    useEffect(() => {
        updateFormFields();
        dismissMessageBar();

    }, [props.panelIsEdit, props.selectedUor, props.panelIsOpen]);

    // Click su salva del panel laterale
    const addUorLateralPanelSubmit = () => {

        if (checkUorFormValidity()) {
            let newUor: Partial<IUor> = {
                nome: fields.find(el => el.internalName === 'nome')?.internalValue,
                alias: fields.find(el => el.internalName === 'alias')?.internalValue,
                sigla: fields.find(el => el.internalName === 'sigla')?.internalValue,
                parentId: props.selectedUor?.id,
                attiva: true
            };

            newUor.iaEnabled = props.iaAssistantEnabled
                ? fields.find(el => el.internalName === 'iaEnabled')?.internalValue
                : false;

            props.onSubmit(newUor);
            resetFormFields();
        }

    }
    const updateFormFields = () => {
        let newInitialFields = [...initialFields];
        if (props.iaAssistantEnabled) {
            newInitialFields.push({
                displayName: "Elaborazione mail con IA",
                internalName: "iaEnabled",
                sharepointType: "Yes/No",
                controlType: "boolean",
                required: false,
                readonly: false,
                disabled: false,
                system: false,
                internalValue: false,
                valid: false,
                touched: false
            } as IField
            );
        }
        if (props.panelIsEdit && props.selectedUor) {
            newInitialFields = newInitialFields.map(el => {
                return {
                    ...el,
                    internalValue: props.selectedUor![el.internalName]
                };
            });
        }
        setFields(newInitialFields);
    }

    const resetFormFields = () => {

        let newFields = fields.map(el => {
            return { ...el, internalValue: null, touched: false, valid: true };
        });
        setFields(newFields);
    }


    const checkUorFormValidity = (): boolean => {

        let isValid = true;


        const updatedProtocolFields = fields.map((item, index) => {
            let fieldValidity = AppUtilities.checkFieldValidity(item);
            if (!fieldValidity)
                isValid = false;

            return {
                ...item,
                touched: true,
                valid: fieldValidity
            }
        });
        setFields(updatedProtocolFields);
        if (isValid) {
            dismissMessageBar();
        }
        else {
            setMessageBarText('Compilare correttamente i campi');
            setMessageBarType(MessageBarType.error);
            showMessageBar();
        }

        return isValid;
    }


    const inputChangedHandler = (newField: IField) => {

        const updatedFields = [...fields];
        let itemIndex = updatedFields.findIndex(el => el.internalName === newField.internalName);
        updatedFields[itemIndex] = { ...newField };

        setFields(updatedFields);
    }

    const onDismiss = () => {
        resetFormFields();
    }

    const onRenderLateralPanelFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Salva"
                    onClick={addUorLateralPanelSubmit}

                />
                <DefaultButton
                    onClick={props.onDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }


    return (
        <React.Fragment>
            <Panel
                key='addEditUorPanel'

                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'600px'}
                headerText={props.panelHeaderText}
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={props.onDismiss}
                onRenderFooterContent={onRenderLateralPanelFooterContent}
                // Stretch panel content to fill the available height so the footer is positioned
                // at the bottom of the page
                isFooterAtBottom={false}
            >
                {messageBarIsVisible &&
                    <MessageBar
                        messageBarType={messageBarType}
                        isMultiline={false}
                        onDismiss={dismissMessageBar}
                        dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
                }

                <CircleLoader loaderClass='loader-large' loading={loading} />
                <div className={"flex flex-column position-relative overflow-hidden"}>

                    <div className={`position-relative my-scroll-div`}>

                        <DynamicForm
                            fields={fields}
                            onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}
                        />

                    </div>
                </div>

                {props.selectedUor && !props.panelIsEdit &&
                    <Text variant={'mediumPlus'} styles={textStyles}>Stai creando la nuova UOR sotto "{props.selectedUor.nome}"</Text>}
            </Panel>



        </React.Fragment>


    );

}

export default AddEditUor;


